import SwitchInput from 'components/field/SwitchInput';
import FormItem from 'components/form/FormItem';

const ActivateStore = ({ isLoading }) => (
	<FormItem label="activateStore" isLoading={isLoading} direction="row-reverse">
		<SwitchInput name="active" />
	</FormItem>
);

export default ActivateStore;
